import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import {
  useRecoilState,
  useRecoilValue,
} from 'recoil';
import {
  isAdmin,
  subMenuState,
} from 'state';
import styled from 'styled-components';
import CoPopup from 'view/pages/Communication/components/CoPopup';
import Instructor from 'view/pages/Members/SubPage/Instructor';
import InstructorAppList from 'view/pages/Members/SubPage/InstructorAppList';
import Users from 'view/pages/Members/SubPage/Users';

import {
  ContentBox,
  Contents,
  Overlay,
} from '../../components';

interface StyledComponentProps {
    width?: string;
    display?: string;
}

export const returnColor = (text) => {
    switch (text) {
        case "New":{
            return "#FFC8DD"
        }
        case "Completed":{
            return "#9AE3B7"
        }
        case "Received":{
            return "#B0CBFF"
        }
        default:
            break;
    }
};

const Members = () => {
    const navigate = useNavigate()
    const isAdminState = useRecoilValue(isAdmin);
    const [subMenu, setSubMenu] = useRecoilState(subMenuState);
    const [onPopup, setOnpopup] = useState(false);

    const onClickPopup = () => {
        setOnpopup(v => !v)
    };
    
    console.log('onPopup', onPopup)
    const el = () => {
        switch (subMenu) {
            case "Whoflex Members": {
                return <Users onClickPopup={onClickPopup} />;
            }
            case "Whoflex Instructor": {
                return <Instructor onClickPopup={onClickPopup} />;
            }
            case "Instructor Application": {
                return <InstructorAppList onClickPopup={onClickPopup} />;
            }
            default:
                break;
        }
    };
    console.log('isAdminState', isAdminState)
    console.log('navigate', navigate)
    // useEffect(()=>{
    //     setSubMenu("Instructor Application")
    // },[])
    return (
        <Container>
            {
                onPopup &&
                <Overlay filter={true}>
                <CoPopup onClickPopup={onClickPopup}/>
              </Overlay>
            }        
            <ContentsWrap>
                    <ContentBox>
                        <Contents title={subMenu}>{el()}</Contents>
                    </ContentBox>
            </ContentsWrap>

        </Container>
    );
};
export default Members;

const Container = styled.div``;
const ContentsWrap = styled.div`
    display: flex;
    width: 100%;
`;
const Wrap = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    flex: 1;
    position: relative;
`;


